import React from 'react'

import { Heading, PortalPage } from 'component-library-next'

import { getAppointmentsPath } from '@app/modules/Appointments'
import { getAuditReportsPath } from '@app/modules/AuditReports'
import { getClientsPath } from '@app/modules/CustomerList'
import lawyerAppointmentIcon from '@app/modules/Overview/assets/lawyerAppointments@2x.png'
import lawyerMessageIcon from '@app/modules/Overview/assets/lawyerMessages@2x.png'
import lawyerSearchClientsIcon from '@app/modules/Overview/assets/lawyerSearchClients@2x.png'
import TipPreview from '@app/modules/Overview/Components/TipPreview'
import { NavBar } from '@app/NavBar'

export const OverviewPage = () => {
  return (
    <NavBar title='Überblick'>
      <PortalPage hideFooter>
        <Heading size='medium'>
          <span>Überblick</span>
        </Heading>
        <p className='subheading-text'>
          Durchsuchen Sie Ihre Mandanten-Datenbank, lesen und beantworten Sie Ihre Nachrichten.
        </p>

        <div className='tips-wrapper'>
          <TipPreview
            url={getClientsPath()}
            imageSrc={lawyerSearchClientsIcon}
            title='Mandanten'
            text='Durchsuchen Sie Ihre Mandanten-Datenbank.'
          />

          <TipPreview
            url={getAuditReportsPath()}
            imageSrc={lawyerMessageIcon}
            title='Prüfungsberichte'
            text='Beantworten Sie offene Fragen und verfassen Prüfungsberichte.'
          />

          <TipPreview
            url={getAppointmentsPath()}
            imageSrc={lawyerAppointmentIcon}
            title='Termine'
            text='Erhalten Sie einen Überblick über Ihre Telefontermine.'
          />
        </div>
      </PortalPage>
    </NavBar>
  )
}
